module.exports = __webpack_public_path__ + "img/advertisement_big.a50c99d0.png";